import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import { IAC_RUNNER_ANNOTATION } from './types';

const iacRunnerFilter = (entity: { metadata: { annotations?: Record<string, string> } }) =>
  Boolean(entity.metadata.annotations?.[IAC_RUNNER_ANNOTATION]);

const iacCicdContent = EntityContentBlueprint.make({
  name: 'iac-cicd',
  params: {
    path: '/ci-cd',
    title: 'CI/CD',
    filter: iacRunnerFilter,
    loader: async () => {
      const { IacCicdContent } = await import('./IacCicdContent');
      return <IacCicdContent />;
    },
  },
});

const okeBudgetContent = EntityContentBlueprint.make({
  name: 'oke-budgets',
  params: {
    path: '/budgets',
    title: 'Budgets',
    filter: iacRunnerFilter,
    loader: async () => {
      const { OkeBudgetContent } = await import('./OkeBudgetContent');
      return <OkeBudgetContent />;
    },
  },
});

const iacRunAlertCard = EntityCardBlueprint.make({
  name: 'iac-run-alert',
  params: {
    type: 'info',
    filter: iacRunnerFilter,
    loader: async () => {
      const { IacRunAlertCard } = await import('./IacRunAlertCard');
      return <IacRunAlertCard />;
    },
  },
});

export const iacRunsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [iacCicdContent, okeBudgetContent, iacRunAlertCard],
});
